import { createFileRoute } from '@tanstack/react-router'

import { ClientPortalPublicPage } from '@/pages/client-portal/public/page'

export const Route = createFileRoute('/client-portal/public/$caseId')({
  component: () => <ClientPortalPublicPage />,
  validateSearch: (params) => {
    return {
      companyId: (params?.companyId as number) ?? undefined,
    }
  },
})
